<template>
    <vx-card class="goal shadow-md hover:shadow-lg border-solid border-2 border-transparent hover:border-black text-dark cursor-pointer select-none" :collapseAction="false" :startCollapsed="collapsed" :cardBackground="backgroundColor" :class="{'text-white': paintItWhite}" @click.stop="emitEdit" @contextmenu.prevent="openContextMenu">
      <template v-slot:title>
        <div class="w-full pl-4 pt-4" :class="{'opacity-50': done}">
          <div>
            <span>
              <AnchoredTitle class="font-bold text-xl" :title="goal.title" :titleClasses="done ? 'line-through' : ''"/>

              <!-- <p class="font-semibold" :class="done ? 'line-through text-muted' : ''">{{ goal.title | truncate_dots(60) }}</p> -->
              <!-- <p class="font-smaller" v-if="deadline">{{deadline.toDate() | dateWord}}</p> -->
              <div class="text-sm">
                <Deadline v-if="deadline" :value="deadline.toDate()" class="mr-2" showOverdueDays="true"/>
                <!-- <span v-if="deadline" class="font-semibold mx-1">|</span> -->
                <NoProgressFor :lastProgressOn="lastProgressOn"/>
                <vs-chip v-if="showDream" class="goal__dream m-0 inline-flex">
                    {{ (goal.dream ? goal.dream.title : 'Other') | truncate_dots(40) }}
                </vs-chip>
              </div>
            </span>
          </div>
          <div class="w-full flex items-center" :class="{'mb-0': !customUnits}" @click.stop="">
             <template>
                <vs-slider
                  v-model="sliderProgress"
                  :color="progressColor"
                  class="my-1"
                  :step="1"
                  :max="goal.max"
                  :height="15"
                  :ref="sliderRef"
                  :text-fixed="units"
                />
              </template>

            <p style="width: 5rem" class="ml-4 font-semibold">
              {{ progressPercent }}%
            </p>
          </div>
          <div v-if="customUnits" class="flex justify-start text-sm items-base">
            <feather-icon
                v-if="!done"
                icon="PlusIcon"
                svgClasses="w-4 h-4"
                class="font-bold mr-1"
                :class="actionElementCss"
                @click="addSliderProgress"
              />
            <p>
               <span class="font-semibold">{{ sliderProgress }}</span><span> / {{goal.max}}</span> <span>{{units}}</span>
            </p>
          </div>



          <div class="flex justify-start" v-if="goal.relatedAreas">
            <LifeArea v-for="lifeArea in goal.relatedAreas" :lifeArea="lifeArea" class="mr-1" :showIcon="true" :hideText="true" size="small"/>
            </div>
          </div>


          <div v-if="noBottomBlock" class="mb-2">
            
          </div>
        </div>
      </template>

      <template v-slot:actions>
        <div @click.stop="" class="flex justify-end">
          <feather-icon icon="MoreVerticalIcon" @click="openContextMenu" :class="actionElementCss" svgClasses="h-5 w-5" />
          <!-- </div> -->

          <context-menu id="goals-context-menu" ref="goalCtxMenu">

            <ContextMenuItem :disabled="deadlineThisMonth" title="this month" icon="CalendarIcon" @contextMenuClicked="doThisMonth"/>
            <ContextMenuItem :disabled="deadlineNextMonth" title="next month" icon="CalendarIcon" @contextMenuClicked="doThisNextMonth"/>

            <vs-divider class="my-1"/>

            <ContextMenuColor :value="goal.backgroundColor" @colorChanged="changeColor" :namespace="`${goal.id}-goal`" />
            <vs-divider class="my-1"/>

             <ContextMenuItem v-if="active" title="pause" icon="PauseCircleIcon" @contextMenuClicked="pause"/>

             <ContextMenuItem v-else title="activate" icon="PlayIcon" @contextMenuClicked="activate" />

            <vs-divider class="my-1"/>

            <ContextMenuItem title="edit" icon="EditIcon" @contextMenuClicked="$emit('edit')"/>

            <ContextMenuItem title="delete" icon="Trash2Icon" @contextMenuClicked="destroy" color="text-danger"/>

          </context-menu>


         <!--  <vs-dropdown vs-trigger-click class="cursor-pointer cursor-pointer hover:text-warning">
            <div class="py-1 cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full" >
              <feather-icon icon="MoreVerticalIcon" svgClasses="h-5 w-5" />
            </div>

            <vs-dropdown-menu class="task__menu">

              <vs-dropdown-item v-if="active" @click.stop="pause">
                <span class="flex items-center hover:font-semibold">
                  <feather-icon icon="PauseIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>pause</span>
                </span>
              </vs-dropdown-item>

            <vs-dropdown-item v-if="!active" @click.stop="activate">
                <span class="flex items-center hover:font-semibold">
                  <feather-icon icon="PlayIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>activate</span>
                </span>
            </vs-dropdown-item>

              <vs-dropdown-item v-if="!hideEditActions" @click.stop="$emit('edit')">
                <span class="flex items-center hover:font-semibold">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>edit</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item v-if="!hideEditActions" @click="destroy">
                <span class="flex items-center text-danger hover:font-semibold">
                  <feather-icon icon="Trash2Icon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>delete</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown> -->

          <feather-icon class="cursor-pointer hover:text-warning" icon="ChevronRightIcon" svgClasses="h-5 w-5" @click.stop="$emit('edit')" />
        </div>
      </template>
    </vx-card>
</template>
<script>
import _ from 'lodash'
import DoubleClick from '../Generic/DoubleClick'
import LazyUpdateMixin from '../Generic/LazyUpdateMixin'
import progressColor from '@/helpers/progressColor'
import { midnight, areEqual, endOfMonth, endOfNextMonth, ensuredDateEqual} from '@/helpers/date'
import { computeProgressPercent } from '@/models/Goal'
import trackAnalytics from '@/helpers/trackAnalytics'
import LifeArea from './../Stories/LifeArea'

export default {
  components: {
    DoubleClick,
    LifeArea
  },
  mixins: [LazyUpdateMixin],
  props: {
    goal: {
      type: Object,
      required: true,
    },
    showDream: {
      type: Boolean,
      required: false,
      default: () => true,
    },
    forceCollapsed: {
      type: Boolean,
      default: () => true,
    },
    showProgressSlider: {
      type: Boolean,
      default: () => true,
    },
    forceJustifyIcon: {
      type: Boolean,
      default: () => false,
    },
    compact: {
      type: Boolean,
      default: () => false,
    },
    hideEditActions: {
      type: Boolean,
      default: () => false,
    }
  },
  data () {
    return {
      sliderProgress: 0,
      lastProgressSlider: null
    }
  },
  watch: {
    'goal': {
      immediate: true,
      handler (goal) {
        if (goal) {
          this.sliderProgress = goal.progress || 0
          // this.forceUpdateSlider()
        }
      }
    },
    'goal.max' : {
      immediate: false,
      handler () {
        // console.log(this.progressEntity.title, 'progressEntity.max watcher')
        // this.sliderProgress = this.progressEntity.progress || 0
        // this.delayed(this.updateProgressBySlider)
        this.forceUpdateSlider()
      }
    },
    'sliderProgress': {
      immediate: false,
      async handler () {
        // console.log(this.goal.title, 'sliderProgress watcher', sliderProgress)
        this.delayed(this.persistProgress)

        if (this.done) {
          this.$store.dispatch('PLAY_SOUND_EFFECT', 'tada')
          this.notifier.completedGoal(this.$store)
        }

        this.lastProgressSlider = new Date()
      }
    },
  },

  computed: {
    backgroundColor () {
      switch (this.goal.backgroundColor) {
      case '#000000': return 'linear-gradient(to bottom right, #000000, #4C4C4C)'
      case '#3D3270': return 'linear-gradient(to bottom right, #3D3270, #776F9A)'
      case '#424CE2': return 'linear-gradient(to bottom right, #424CE2, #7A81EA)'
      case '#FC9905': return 'linear-gradient(to bottom right, #FC9905, #FCB750)'
      case '#2196F3': return 'linear-gradient(to bottom right, #2196F3, #63B5F6)'
      case '#9C28B1': return 'linear-gradient(to bottom right, #9C28B1, #B968C8)'
      case '#E91D62': return 'linear-gradient(to bottom right, #E91D62, #EF6091)'
      case '#F34336': return 'linear-gradient(to bottom right, #F34336, #F67B72)'
      case '#FFB800': return 'linear-gradient(to bottom right, #FFB800, #FFCD4C)'
      case '#21C228': return 'linear-gradient(to bottom right, #21C229, #63D469)'
      default: return this.goal.backgroundColor
      }
    },
    noBottomBlock () {
      return !this.customUnits && this.relatedAreasPresent
    },
    units () {
      if (this.customUnits) {
        if (this.goal.customUnitsText) {
          return ' ' + this.goal.customUnitsText
        } else {
          ''
        }
      } else {
        return '%'
      }
    },
    relatedAreasPresent () {
      return !(this.goal.relatedAreas &&
      this.goal.relatedAreas.length > 0)
    },
    customUnits () {
      return this.goal.max !== 100 || this.goal.targetValueType === 'custom'
    },
    lastProgressOn () {
      return (this.goal.lastProgressOn && this.goal.lastProgressOn.toDate()) ||
      this.goal.createdAt.toDate()
    },
    paintItWhite () {
      return this.goal.backgroundColor
    },
    subgoalsPresent () { return _.size(this.subgoals) > 0 }, // progress mixin
    deadline () {
      return this.goal.deadline
    },
    active () {
      return this.goal.status !== 'paused'
    },
    collapsed () {
      return this.forceCollapsed || !this.subgoalsPresent
    },
    isMobile () {
      return this.$store.getters.isMobile
    },
    progressColor () {
      return progressColor(this.progressPercent)
    },
    sliderRef () {
      return `slide-${this.goal.id}`
    },
    progressPercent () {
      return computeProgressPercent(
        { currentProgress: this.sliderProgress, max: this.goal.max }
      )
    },
    doneOn () {
      return this.goal.doneOn
    },
    done () {
      return this.progressPercent === 100
    },
    deadlineThisMonth () {
     return ensuredDateEqual(this.goal.deadline, endOfMonth())
    },
    deadlineNextMonth () {
     return ensuredDateEqual(this.goal.deadline, endOfNextMonth())
    },
  },
  methods: {
    addSliderProgress () {
      if (!this.done) {
        this.sliderProgress = this.sliderProgress + 1
      }
    },
    emitEdit () {
      const slidingRecently = this.lastProgressSlider &&
      ((new Date() - this.lastProgressSlider) < 300)

      if (!slidingRecently) {
        this.$emit('edit')
      }
    },
    openContextMenu () {
      this.$root.$emit('closeAllContextMenus')

      if (this.$refs.goalCtxMenu) {
        this.$refs.goalCtxMenu.open()
      }
    },
    newProgresses (progressPercent) {

      const currentProgress = { date: midnight(), progressPercent }

      if (this.goal.progressesData && this.goal.progressesData.length > 0) {
        console.log('this.goal.progressesData',this.goal.progressesData)
        const goalProgressesData = [...this.goal.progressesData]
        console.log('goalProgressesData', goalProgressesData)
        const last = goalProgressesData.shift()

        if (areEqual(currentProgress.date, last.date.toDate()) ) {
          return [currentProgress, ...goalProgressesData]
        } else {
          return [currentProgress, last, ...goalProgressesData]
        }
      } else {
        return [currentProgress]
      }
    },
    async persistProgress () {
      const progress = this.sliderProgress
      const progressPercent = this.progressPercent

      const doneOn = this.done ? midnight() : null
      const lastProgressOn = midnight()

      const progressesData = this.newProgresses(progressPercent)

      this.$store.dispatch('UPDATE_GOAL', { goal: this.goal, updateFields: { progress, progressPercent, doneOn, lastProgressOn, progressesData } })
    },
    forceUpdateSlider () {
      if (this.$refs[this.sliderRef]) {
        this.$forceNextTick(() => this.$refs[this.sliderRef].changePosition())
      }
    },
    activate () {
      this.$store.dispatch('UPDATE_GOAL', { goal: this.goal, updateFields: { status: 'active' } })
    },
    changeColor (backgroundColor) {
      this.$store.dispatch('UPDATE_GOAL', { goal: this.goal, updateFields: { backgroundColor } })
    },
    pause () {
      this.$store.dispatch('UPDATE_GOAL', { goal: this.goal, updateFields: { status: 'paused' } })
    },
    doThisMonth () {
      this.$store.dispatch('UPDATE_GOAL', { goal: this.goal, updateFields: { deadline: endOfMonth() } })
    },
    doThisNextMonth () {
      this.$store.dispatch('UPDATE_GOAL', { goal: this.goal, updateFields: { deadline: endOfNextMonth() } })
    },
    destroy () {
      this.$store.dispatch('DELETE_GOAL', { goal: this.goal })
      trackAnalytics(this, 'app_action', 'delete_goal', null, this.$store.getters.daysFromRegistration)
    },
  },
  created () {
    this.$root.$on('closeAllContextMenus', () => {
      if (this.$refs.goalCtxMenu) {
        this.$refs.goalCtxMenu.ctxVisible = false
      }
    })
  },
}
</script>

<style lang="scss">

.goal {
  .vx-card__header {
    padding: 0.3rem !important
  }
}

</style>

<style lang="scss">
.goal {
  &__dream {
    float: none;
    display: inline-block;
    top: -3px;
    @media (max-width: 768px) {
      top: 0px;
    }
  }
  &__icon {
    display: inline-block;
    position: relative;
    top: 6px;
    margin-top: -10px;
  }
  &__title {
    display: inline !important;
  }
  &__handle {
    display: inline-flex;
    position: relative;
    top: 5px;
    margin-top: -10px;
  }
  &__edit {
    display: inline-flex;
    position: relative;
  }
  &__menu {
    min-width: 180px;
  }
}

.vs-slider {
  height: 6px;
}
.vs-slider--circle {
  top: -8px;
  width: 20px;
  height: 20px;
}

.ghost-goal {
  opacity: 0.2;
}
.handle {
  cursor: move;
}

.vs-popup--header {
  background: #ffffff
}

.vs-popup--title h3 {
  font-size: 1.5rem;
}

.add-dropdown__menu {
  font-size: 1.3rem;
}
</style>
